// Mutations
export const SET_CAMPAIGN = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.campaign.data = payload
    state.campaign.lastUpdate = new Date()
  }
}
export const ADD_CAMPAIGN = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.campaign.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.campaign.data.push(data)
      }
    })
  }
}
export const SET_CAMPAIGN_LOADING = (state, payload) => {
  state.campaignFiles.loading = payload
}

export const SET_CAMPAIGN_FILES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.campaignFiles.data = payload
    state.campaignFiles.lastUpdate = new Date()
  }
}
export const ADD_CAMPAIGN_FILES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.campaignFiles.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.campaignFiles.data.push(data)
      }
    })
  }
}
export const SET_CAMPAIGN_FILES_LOADING = (state, payload) => {
  state.campaignFiles.loading = payload
}
export const SET_PARTICIPANTS_CAMPAIGN = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.participantsCampaign.data = payload
    state.participantsCampaign.lastUpdate = new Date()
  }
}
export const ADD_PARTICIPANTS_CAMPAIGN = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.participantsCampaign.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.participantsCampaign.data.push(data)
      }
    })
  }
}
export const SET_PARTICIPANTS_CAMPAIGN_LOADING = (state, payload) => {
  state.participantsCampaign.loading = payload
}

